import React, { useMemo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import get from "lodash.get";

import { refreshToken } from "@ts-digital/digital-login-component";

import Page from "../../components/general/page";
import Spinner from "../../components/general/spinner";

import { ChildApp } from "./styled";

const DbxChildAppView = ({ auth, customLaunchData, itemId, studio, url, user }) => {
  const launchData = useMemo(() => {
    const studioInfo = studio && studio.list?.find((s) => s.uuid === itemId);
    let launchData = {};
    launchData = {
      cookieConsents: {},
      item: {
        id: itemId,
        classifier: studioInfo?.classifier,
        description: studioInfo?.ragioneSociale,
        taxId: studioInfo?.codiceFiscale,
        vatNumber: studioInfo?.partitaIva,
        ncsId: "", // TODO: trovare ncsid
        taxRegion: studioInfo?.taxRegion
      },
      settings: {
        language: get(user, "profile.language")
      },
      user: {
        email: get(user, "profile.email"),
        firstName: get(user, "profile.firstName"),
        id: get(user, "profile.uuid"),
        lastName: get(user, "profile.lastName"),
        ncsId: get(user, "profile.ncsId"),
        token: get(auth, "loginAuth.securityToken")
      },
      from: "dbx"
    };

    return { ...launchData, ...customLaunchData };
  }, [auth, customLaunchData, itemId, studio, user]);

  return (
    <Page noHeaderContent className="contentStructure childApp">
      <ChildApp
        url={url}
        suppliedMethods={{
          getNewAccessToken: () => refreshToken(auth)
        }}
        launchData={launchData}
        launchingPlaceholder={<Spinner />}
        // onLaunched={() => {
        //   // The child app may have its own Elevio and UserVoice
        //   // launchers. When it does, we hide the ts-portale ones
        // }}
      />
    </Page>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  itemId: state.main.accountantUuidSelected,
  studio: state.studio,
  user: state.user
});

const composeHoc = compose(connect(mapStateToProps));

export default composeHoc(DbxChildAppView);
